import React, { Component } from 'react';
import './index.scss';
import Button from '../Button';
import PostCard from '../PostCard';
import PostList from '../PostList';
import MediaQuery from 'react-responsive';
import $ from 'jquery';

class PostPage extends Component {
  componentDidMount() {
    this.props.loadData();
  }
  _showText = (content , showNum) =>{
    if( content.length > showNum){
        var textLimit = content.substring(0,showNum).concat('......');

    }else{
        var textLimit = content.concat('......');
    }
    return textLimit;
  }

  render() {
    const{
      directory = "投稿活動" ,title ="想說卻沒說的還很多"
    } = this.props;

    const{ postList } = this.props;

    return (
        <div className="content-section -post">
          <div className="container -post -horizon-padding -pad-top">
            <div className="post-title">
              <p className="post-directory">{directory}</p>
              <h3 className="title">{title}</h3>
            </div>
            <div className="content desktop-flex">
              <div className="intro-post" dangerouslySetInnerHTML={{__html: this.props.intro}}></div>
              <div className="flex">
                <MediaQuery query='(min-height: 900px)'>
                  <MediaQuery query='(max-width: 599px)'>
                  {
                    postList &&
                    postList.data &&
                    postList.data.length > 0 &&
                    postList.data.slice(0,2).map((post,i) =>{
                      return(
                        <div className="post-card-wrapper -PostPage" key={i}>
                        <PostCard uuid={post.uuid} hashId={`#${post.category}`} title={post.title}
                        article={this._showText(post.content, 80)}></PostCard>
                        </div>
                        )
                    })
                  }
                  </MediaQuery>
                  <MediaQuery query='(min-width: 600px)'>
                  {
                    postList &&
                    postList.data &&
                    postList.data.length > 0 &&
                    postList.data.slice(0,2).map((post,i) =>{
                      return(
                        <div className="post-card-wrapper -PostPage" key={i}>
                        <PostCard uuid={post.uuid} hashId={`#${post.category}`} title={post.title} article={this._showText(post.content,50)}></PostCard>
                        </div>
                        )
                    })
                  }
                  </MediaQuery>
                </MediaQuery>
                <MediaQuery query='(max-height: 899px)'>
                  <MediaQuery query='(max-width: 599px)'>
                  {
                    postList &&
                    postList.data &&
                    postList.data.length > 0 &&
                    postList.data.slice(0,1).map((post,i) =>{
                      return(
                        <div className="post-card-wrapper -PostPage" key={i}>
                        <PostCard uuid={post.uuid} hashId={`#${post.category}`} title={post.title}
                        article={this._showText(post.content, 80)}></PostCard>
                        </div>
                        )
                    })
                  }
                  </MediaQuery>
                  <MediaQuery query='(min-width: 600px)'>
                  {
                    postList &&
                    postList.data &&
                    postList.data.length > 0 &&
                    postList.data.slice(0,1).map((post,i) =>{
                      return(
                        <div className="post-card-wrapper -PostPage" key={i}>
                        <PostCard uuid={post.uuid} hashId={`#${post.category}`} title={post.title} article={this._showText(post.content,50)}></PostCard>
                        </div>
                        )
                    })
                  }
                  </MediaQuery>
                </MediaQuery>

                <div className="post-btn-wrapper">
                  <a className="post-btn" href="/post/create" target="_blank" onClick={() => $.fn.fullpage.destroy('all')}>
                    我要投稿
                  </a>
                  <Button text="看更多文章" linkTo="/posts" clickEvent={() => $.fn.fullpage.destroy('all')}></Button>
                </div>

              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default PostPage;



// WEBPACK FOOTER //
// ./src/components/PostPage/pure.js